import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space } from 'antd';
import type { FC } from 'react';
import { useState } from 'react';
import UploadWineModal from './UploadWineModal';

export const ActionView: FC<{
  selectedRowKeys: string[];
  onAddWine: () => void;
  onDelete: (ids: string[]) => void;
}> = ({ selectedRowKeys, onAddWine, onDelete }) => {
  const [uploadModalVisible, setUploadModalVisible] = useState(false);

  const showUploadModal = () => {
    setUploadModalVisible(true);
  };

  const closeUploadModal = () => {
    setUploadModalVisible(false);
  };

  const uploadSuccess = () => {
    closeUploadModal();
  };

  return (
    <Space>
      <Button
        type="default"
        icon={<UploadOutlined />}
        onClick={showUploadModal}
      >
        Upload Wine List
      </Button>
      {selectedRowKeys.length > 0 && (
        <Popconfirm
          title="Delete selected wines"
          description={`Are you sure you want to delete ${selectedRowKeys.length} wines?`}
          onConfirm={() => onDelete(selectedRowKeys)}
          okType="danger"
        >
          <Button type="primary" danger disabled={selectedRowKeys.length === 0}>
            Delete Selected
          </Button>
        </Popconfirm>
      )}
      <Button type="primary" icon={<PlusOutlined />} onClick={onAddWine}>
        Add Wine
      </Button>

      <UploadWineModal
        visible={uploadModalVisible}
        onCancel={closeUploadModal}
        onSuccess={uploadSuccess}
      />
    </Space>
  );
};
